<template>
	<div class="box">
		<slot name="title" class="box__title"></slot>
		<slot name="description"></slot>
		<slot name="buttons" class="box__buttons"></slot>
	</div>
</template>

<script>

export default {
	components: {  },

	mounted () {

	},

	data () {
		return {

		}
	},

	props: {

	},

	computed: {

	},

	methods: {

	}
}
</script>
<style scoped>
	.box { display: flex; flex-direction: column; padding: 50px 50px 40px; box-shadow: 0 10px 30px rgb(51 71 91 / 12%); margin: 0 15px; border-radius: 10px; border: 1px solid #e8e8e861; }
	.box:hover { transform: scale(1.014); box-shadow: 0 10px 50px -5px rgba(51,71,91,0.12); }
	.box__title { margin-bottom: 10px; }
	.box__buttons { margin-top: 30px; }

	@media (max-width: 900px) {
		.box { text-align: center; align-items: center; }
	}
</style>
